import _JSXStyle from "styled-jsx/style";
import React from 'react';
import useTheme from '../use-theme';
import ClearIcon from '../utils/clear-icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ModalCloseButton = ({
  onClick,
  disabled,
  ...props
}) => {
  const theme = useTheme();

  const clickHandler = event => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    onClick && onClick(event);
  };

  return /*#__PURE__*/_jsxs("div", {
    onClick: clickHandler,
    ...props,
    className: _JSXStyle.dynamic([["1382096932", [theme.layout.gapQuarter, theme.layout.gapQuarter, disabled ? 'not-allowed' : 'pointer', theme.layout.gapQuarter, theme.palette.accents_4]]]) + " " + (props && props.className != null && props.className || "close-icon"),
    children: [/*#__PURE__*/_jsx(ClearIcon, {
      plain: true,
      size: 18,
      fill: "currentColor"
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1382096932",
      dynamic: [theme.layout.gapQuarter, theme.layout.gapQuarter, disabled ? 'not-allowed' : 'pointer', theme.layout.gapQuarter, theme.palette.accents_4],
      children: `.close-icon.__jsx-style-dynamic-selector{position:absolute;z-index:1;top:${theme.layout.gapQuarter};right:calc(${theme.layout.gapQuarter} * 0.5);margin:0;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:auto;cursor:${disabled ? 'not-allowed' : 'pointer'};box-sizing:border-box;-webkit-transition:opacity 250ms ease 0s;transition:opacity 250ms ease 0s;padding:${theme.layout.gapQuarter};color:${theme.palette.accents_4};}.close-icon.__jsx-style-dynamic-selector:hover{opacity:0.8;}.close-icon.__jsx-style-dynamic-selector svg{color:currentColor;}`
    })]
  });
};

const MemoModalCloseButton = /*#__PURE__*/React.memo(ModalCloseButton);
export default MemoModalCloseButton;